/* eslint-disable no-prototype-builtins */
import { EVENT_TYPES } from './constants';

export const calendarEventTransformer = (calendarEvent: any) => ({
  ...calendarEvent,
});

/**
 * This transformer help us to prepare the list of groups displayed
 * in the calendar event form. Just in case we want to display a diffent label
 * In select options. In this case we need to prepare the groups
 * tagged as 'student' to display the first_name and last_name as name,
 */
export const groupListItemTransformer = (group: any) => {
  
  const CURRENT_PROPERTY = group?.hasOwnProperty('metadata') ? 'metadata' : 'tags';
  const tags = group[CURRENT_PROPERTY].map((tag: any) => tag.name);

  if (tags.includes(EVENT_TYPES.STUDENT.toLowerCase())) {
    const name = `${group.first_name || ''} ${group.last_name || ''}`;

    return {
      ...group,
      name: name === '' ? group.name : name,
    };
  }

  return group;
};
